import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import { fromAnyDateToZuluDayBgn, fromAnyDateToZuluDayEnd } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';
import isNotMissing from 'utils/predicates/any/isNotMissing.util';

const L = logger('beCashup'); // eslint-disable-line no-unused-vars

const fromDtoToRaw = void 1; // for printing in console, you can use: L.wrap('fromDtoToRaw()', alwaysSame);

// SEE: https://getslick.atlassian.net/browse/GS-13449
// transactions.api: GET /cashup/:salonId/all/  →  replaces old: /cashup/:salonId/
// transactions.api: GET /cashup/:salonId/personal/ -> replaces old: /cashup/:salonId/

const reconfigure = (config) => (options, extra) => ({
  ...options,
  ...config,
  base: CONF.transactionApiRoot,
  params: {
    ord: extra?.desc ? '-created' : 'created',
    pag: fromAnyToTrimmed(extra?.pageNumber) || void 1,
    bgn: fromAnyDateToZuluDayBgn(extra?.bgn) || fromAnyDateToZuluDayBgn(extra?.begin),
    end: fromAnyDateToZuluDayEnd(extra?.end),
  },
});

const inertRawRead = reconfigure({ inert: true, fromDto: fromDtoToRaw });
const activeRawRead = reconfigure({ inert: false, fromDto: fromDtoToRaw });

export const ibeCashupAllRead = actionEndpointBe(
  'ibeCashupAllRead',
  H.get,
  'cashup/:salonId/all/?start=:bgn&end=:end',
  inertRawRead,
);

export const abeCashupAllRead = actionEndpointBe(
  'abeCashupAllRead',
  H.get,
  'cashup/:salonId/all/?start=:bgn&end=:end',
  activeRawRead,
);

export const ibeCashupAllPagedRead = actionEndpointBe(
  'ibeCashupAllPagedRead',
  H.get,
  'cashup/:salonId/all/?start=:bgn&end=:end&page=:pag?',
  inertRawRead,
);

export const abeCashupAllPagedRead = actionEndpointBe(
  'abeCashupAllPagedRead',
  H.get,
  'cashup/:salonId/all/?start=:bgn&end=:end&page=:pag?',
  activeRawRead,
);

export const ibeCashupAllOrderedRead = actionEndpointBe(
  'ibeCashupAllOrderedRead',
  H.get,
  'cashup/:salonId/all/?start=:bgn&end=:end&ordering=:ord?',
  inertRawRead,
);

export const abeCashupAllOrderedRead = actionEndpointBe(
  'abeCashupAllOrderedRead',
  H.get,
  'cashup/:salonId/all/?start=:bgn&end=:end&ordering=:ord?',
  activeRawRead,
);

export const ibeCashupAllCombinedRead = (options) => {
  // NOTE: back end doesn't handle extra parameters, and linkTo utility can't remove them automatically

  if (isNotMissing(options?.desc)) {
    return ibeCashupAllOrderedRead(options);
  }

  if (isNotMissing(options?.pageNumber)) {
    return ibeCashupAllPagedRead(options);
  }

  return ibeCashupAllRead(options);
};

export const abeCashupAllCombinedRead = (options) => {
  // NOTE: back end doesn't handle extra parameters, and linkTo utility can't remove them automatically

  if (isNotMissing(options?.desc)) {
    return abeCashupAllOrderedRead(options);
  }

  if (isNotMissing(options?.pageNumber)) {
    return abeCashupAllPagedRead(options);
  }

  return abeCashupAllRead(options);
};

export const ibeCashupOwnRead = actionEndpointBe(
  'ibeCashupOwnRead',
  H.get,
  'cashup/:salonId/personal/?start=:bgn&end=:end',
  inertRawRead,
);

export const abeCashupOwnRead = actionEndpointBe(
  'abeCashupOwnRead',
  H.get,
  'cashup/:salonId/personal/?start=:bgn&end=:end',
  activeRawRead,
);

export const ibeCashupOwnPagedRead = actionEndpointBe(
  'ibeCashupOwnPagedRead',
  H.get,
  'cashup/:salonId/personal/?start=:bgn&end=:end&page=:pag?',
  inertRawRead,
);

export const abeCashupOwnPagedRead = actionEndpointBe(
  'abeCashupOwnPagedRead',
  H.get,
  'cashup/:salonId/personal/?start=:bgn&end=:end&page=:pag?',
  activeRawRead,
);

export const ibeCashupOwnOrderedRead = actionEndpointBe(
  'ibeCashupOwnOrderedRead',
  H.get,
  'cashup/:salonId/personal/?start=:bgn&end=:end&ordering=:ord?',
  inertRawRead,
);

export const abeCashupOwnOrderedRead = actionEndpointBe(
  'abeCashupOwnOrderedRead',
  H.get,
  'cashup/:salonId/personal/?start=:bgn&end=:end&ordering=:ord?',
  activeRawRead,
);

export const abeCashupOwnCombinedRead = (options) => {
  // NOTE: back end doesn't handle extra parameters, and linkTo utility can't remove them automatically

  if (isNotMissing(options?.desc)) {
    return abeCashupOwnOrderedRead(options);
  }

  if (isNotMissing(options?.pageNumber)) {
    return abeCashupOwnPagedRead(options);
  }

  return abeCashupOwnRead(options);
};

export const ibeCashupOwnCombinedRead = (options) => {
  // NOTE: back end doesn't handle extra parameters, and linkTo utility can't remove them automatically

  if (isNotMissing(options?.desc)) {
    return ibeCashupOwnOrderedRead(options);
  }

  if (isNotMissing(options?.pageNumber)) {
    return ibeCashupOwnPagedRead(options);
  }

  return ibeCashupOwnRead(options);
};
